const carouselItems = [
  {
    title: '2026暑期档：国产科幻崛起',
    desc: '多部国产科幻巨制扎堆上映，特效升级、剧情在线，国产科幻电影迎来高光时刻。麻花影院已同步上线多部热门科幻新片，高清画质免费观看。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20scene%20with%20dramatic%20golden%20and%20amber%20lighting%2C%20epic%20space%20atmosphere%2C%20warm%20cinematic%20tones%2C%20film%20production%20quality%2C%20dark%20background%20with%20bright%20highlights%2C%20no%20text&width=1000&height=600&seq=mahua-carousel-01&orientation=landscape',
    tag: '专题',
    stats: '18部新片',
  },
  {
    title: '悬疑剧迷必看：年度口碑黑马',
    desc: '从《迷雾追踪》到《暗夜行者》，今年悬疑题材佳作频出，豆瓣高分不断。麻花影院已整理悬疑剧合集，一部不落全收录。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20noir%20cinematic%20scene%20with%20foggy%20dark%20streets%2C%20warm%20filtered%20street%20lamp%20glow%2C%20suspenseful%20film%20noir%20aesthetic%2C%20amber%20and%20golden%20lighting%2C%20shadowy%20atmosphere%2C%20no%20text&width=1000&height=600&seq=mahua-carousel-02&orientation=landscape',
    tag: '合集',
    stats: '12部精选',
  },
  {
    title: '经典港片修复版重映计划',
    desc: '一批经典香港电影经过4K修复重新上线，画质焕然一新。麻花影院免费观看专区已同步更新，重温黄金年代的港片魅力。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20aesthetic%20with%20warm%20nostalgic%20tones%2C%20vintage%20film%20texture%2C%20golden%20era%20movie%20atmosphere%2C%20soft%20sepia%20and%20amber%20lighting%2C%20cinematic%20composition%2C%20dark%20background&width=1000&height=600&seq=mahua-carousel-03&orientation=landscape',
    tag: '经典',
    stats: '50+部影片',
  },
  {
    title: '综艺爆款：《欢乐喜剧人》回归',
    desc: '现象级喜剧综艺《欢乐喜剧人》全新一季重磅回归，阵容更豪华、笑点更密集。麻花影院每周同步更新，欢笑不缺席。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20stage%20show%20performance%20with%20colorful%20theatrical%20lighting%2C%20warm%20golden%20spotlights%2C%20entertainment%20show%20atmosphere%2C%20dynamic%20stage%20production%2C%20joyful%20celebratory%20vibe%2C%20dark%20audience%20background&width=1000&height=600&seq=mahua-carousel-04&orientation=landscape',
    tag: '热播',
    stats: '每周更新',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            热播专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            聚焦当下最热影视专题，一站看遍精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-md text-xs font-medium text-background-50 bg-accent-500">
                    {item.tag}
                  </span>
                  <span className="px-2.5 py-1 rounded-md text-xs text-background-50 bg-foreground-900/40 backdrop-blur-sm">
                    {item.stats}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}